import {css} from "@emotion/react";
import moment from "moment";
import React from 'react';

import "react-datepicker/dist/react-datepicker.css";
import {Button} from '../../../Button';
import {Select} from "../../../Select";
import {Spacing} from "../../../Spacing";
import {Card} from "../../../TabsRoute/components/Card";
import {Typography} from "../../../Typography";
import {useAQM} from "../../context";
import {AirSvg} from "../AirSvg";
import {RangeDatePicker, RangeDatePickerProps} from "./components/RangeDatePicker";
import {root} from "./styles";


export const ReportDownload: React.FC = () => {

    const {
        locations: _locations,
        loading,
        fetchReport,
        currentLocation,
        currentRange: currRange,
    } = useAQM();


    const locations = React.useMemo(() => {
        return _locations.map(x => ({
            value: String(x.id),
            label: x.name || String(x.id),
        }));
    }, [_locations]);

    const [selectedLocation, setSelectedLocation] = React.useState({
        label: "", value: "",
    });

    React.useLayoutEffect(() => {
        if (loading.locations) {
            setSelectedLocation({
                value: "",
                label: "Loading sites...",
            });
        } else if (locations.length > 0) {
            const currStrLocId = String(currentLocation?.id);
            const currLocation = locations.find(x => x.value === currStrLocId);
            setSelectedLocation(currLocation || locations[0]);
        } else {
            setSelectedLocation({
                value: "",
                label: "No sites available",
            });
        }
    }, [locations, loading.locations]);


    const [targetDate, setTargetDate] = React.useState(0);


    const handleDateChange: RangeDatePickerProps['onChange'] = (targetDate) => {
        setTargetDate(targetDate);
    };

    const getReportDownloadMsg = () => {
        if (loading.locations) {
            return "Getting locations...";
        }
        if (loading.filters) {
            return "Downloading..."
        }
        return "Report Download";
    };


    React.useEffect(() => {
        if (selectedLocation.value) {
            fetchReport(
                parseInt(selectedLocation.value),
                targetDate,
            );
        }
    }, [
        selectedLocation.value,
        targetDate,
    ])


    return (
        <Card>
            <div css={root}>
                <Spacing h={2}/>
                <Typography variant={"h1"} leftIcon={<AirSvg/>}>Air Quality Monitoring</Typography>
                <Spacing h={3}/>
                <RangeDatePicker
                    onChange={handleDateChange}
                    loading={loading.filters}
                    fromDate={currRange.fromDate}
                    toDate={currRange.toDate}
                />
                <Spacing h={2}/>
                <Select
                    options={locations}
                    value={selectedLocation}
                    fullWidth
                    onChange={value => value && setSelectedLocation(value)}
                />
                <div css={css({height: "100%"})}/>

                <Button disabled={loading.locations || loading.filters} style={{
                    display: "none",
                }} fullWidth onClick={() => {
                    // Do something else!
                }}>
                    {getReportDownloadMsg()}
                </Button>
            </div>
        </Card>
    );
};
